module.exports = __webpack_public_path__ + "static/media/arrow.6c7a52ed.svg";